import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from "docz";
import { DateTimeInput } from "../index";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "datetime-input"
    }}>{`DateTime Input`}</h1>
    <p>{`Base on `}<a parentName="p" {...{
        "href": "https://huynhhuyhiep.github.io/doopage-react-ui-kit/input"
      }}>{`Input`}</a></p>
    <p>{`Related component`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/react-datetime"
        }}>{`https://www.npmjs.com/package/react-datetime`}</a></li>
    </ul>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`Install `}<inlineCode parentName="p">{`moment`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install moment --save
or
yarn add moment
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { DateTimeInput } from '@doopage/react-ui-kit'

const Example = () => <DateTimeInput label={'DateTime Input'}/>;

export default Example;
`}</code></pre>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <h3 {...{
      "id": "normal"
    }}>{`Normal`}</h3>
    <Playground __position={0} __code={'<DateTimeInput\n  label={\'DateTime Input\'}\n  onChange={value => console.log(value)}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      DateTimeInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <DateTimeInput label={'DateTime Input'} onChange={value => console.log(value)} mdxType="DateTimeInput" />
    </Playground>
    <h3 {...{
      "id": "native"
    }}>{`Native`}</h3>
    <Playground __position={1} __code={'<DateTimeInput\n  label={\'Native Date Input\'}\n  onChange={value => console.log(value)}\n  native\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      DateTimeInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <DateTimeInput label={'Native Date Input'} onChange={value => console.log(value)} native mdxType="DateTimeInput" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={DateTimeInput} table mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      